import { createContext, useContext } from 'react';

export interface IMapNavGuardContext {
  openGpsUnavailable: () => void;
}

export const MapNavGuardContext = createContext<IMapNavGuardContext>({
  openGpsUnavailable: () => undefined,
});

export const useMapNavGuard = () => useContext(MapNavGuardContext);
